export default {"src":"/login-app/[GIT_HASH]/_next/static/media/toggle_off.47ab44f7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};